import { Injectable, EventEmitter } from '@angular/core';
// Interfaces
import { IService, DiscussionInterface } from '../../Interfaces';
// Services
import { LogService } from '../log/log.service';
// Types
import { dialogTag, SignInTag } from '../../types';



@Injectable()
export class DialogService implements IService {
  // implements IService
  name = 'DialogService';
  test(name, value) {
    console.log('testing', name, value);
  }
  // implements local variables

  signInTag: SignInTag;

  textShowing: boolean;
  textValue: string;
  textText: string;
  textHeader = 'Information';

  leftButtonText = 'Cancel';
  rightButtonText = 'Yes';

  textTag: dialogTag;

  public OnOpenTextDialog$ = new EventEmitter<dialogTag>(true);
  public OnOpenTextboxDialog$ = new EventEmitter<dialogTag>(true);

  public OnClose$ = new EventEmitter<any>(true);
  public OnClosingTextDialog$ = new EventEmitter<string>(true);
  public OnClosingTextboxDialog$ = new EventEmitter<dialogTag>(true);
  public OnClosingSigninDialog$ = new EventEmitter<any>(true);

  public OnclickLeftTextDialog$ = new EventEmitter<string>(true);
  public OnClickRightTextDialog$ = new EventEmitter<dialogTag>(true);
  public OnClickRightTextboxDialog$ = new EventEmitter<dialogTag>(true);

  constructor(
    private _loggerService: LogService
  ) { }


  ConfirmDialog(cancelButton: string,
    actionButton: string,
    tag: dialogTag) {
    return new Promise((save, nosave) => {
      this._close(tag);
      this.leftButtonText = cancelButton;
      this.rightButtonText = actionButton;
      this.textValue = tag.value;
      this.textHeader = tag.header;
      this.textText = tag.text;
      this.textTag = tag;
      this.textShowing = true;

      this.OnClickRightTextDialog$.subscribe(t => {
        this._loggerService.Debug(this.name, ['DeactivateStep returning right click']);
        save(actionButton);
      });

      this.OnClosingTextDialog$.subscribe(t => {
        this._loggerService.Debug(this.name, ['DeactivateStep returning left click']);
        nosave(cancelButton);
      });
    });

  }

  OpenTextDialog(
    cancelButton: string,
    actionButton: string,
    tag: dialogTag) {
    this._close(tag);
    this.leftButtonText = cancelButton;
    this.rightButtonText = actionButton;
    this.textValue = tag.value;
    this.textHeader = tag.header;
    this.textText = tag.text;
    this.textTag = tag;
    this.textShowing = true;
    this.OnOpenTextDialog$.emit(tag);
  }

  OpenTextboxDialog(
    cancelButton: string,
    actionButton: string,
    tag: dialogTag
  ) {
    this._close(tag);
    this.leftButtonText = cancelButton;
    this.rightButtonText = actionButton;
    this.OnOpenTextboxDialog$.emit(tag);
  }

  OpenSigninDialog(tag: SignInTag) {
    // this._close(tag.signinText);
    this.signInTag = tag;
    console.log(tag);

  }

  CloseTextboxDialog(tag: dialogTag) {
    this.OnClosingTextboxDialog$.emit(tag);
    this._closeAndEmit(tag);
  }

  CloseTextDialog(e: any) {
    this.OnClosingTextDialog$.emit(e);
    this._closeAndEmit(e);
  }

  CloseSigninDialog(e: any) {
    this.signInTag.acepId = e;
    this.OnClosingSigninDialog$.emit(this.signInTag);
    this._closeAndEmit(e);
  }

  ClickRightTextboxDialog(tag: dialogTag) {
    this.OnClickRightTextboxDialog$.emit(tag);
    this._closeAndEmit(tag);
  }

  ClickLeftTextDialog(e: any) {
    this.OnclickLeftTextDialog$.emit(e);
    this._closeAndEmit(e);
  }

  ClickRightTextDialog(e: any) {
    'ClickRightTextDialog cancel'.logWithObject(this.name, e);
    this.OnClickRightTextDialog$.emit(this.textTag);
    this._closeAndEmit(e);
  }

  private _close(e: any) {
    this.signInTag = undefined;
    this.textShowing = false;
    this.textValue = undefined;
  }

  private _closeAndEmit(e: any) {
    this._close(e);
    this.OnClose$.emit(e);
  }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/dialog/dialog.service.ts